import React from 'react';
import { Marker } from 'react-map-gl';
import { Avatar } from 'enspire-manager-framework';

export default function TechnicianMarker({ employee, location, setCursor }) {

    const clockedIn = employee?.timeClock?.clockedIn;

    return (
        <div
            key={employee.id}
            onMouseEnter={() => setCursor('pointer')}
            onMouseLeave={() => setCursor('auto')}
        >
            <Marker
                draggable={false}
                key={employee.id}
                longitude={location.lng}
                latitude={location.lat}
                anchor="bottom"
            >
                <Avatar
                    className="mx-auto"
                    color="white"
                    bgColor="darkGreen"
                    size={65}
                    fontSize={'21'}
                    name={`${employee?.contact?.firstName} ${employee?.contact?.lastName}`}
                    image={employee?.contact?.photoUrl || null}
                    border={`4px solid ${clockedIn ? 'steelblue' : 'white'}`}
                    style={{ marginBottom: '10px' }}
                />
                <div style={{
                    position: 'absolute',
                    bottom: '0px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '0',
                    height: '0',
                    borderLeft: '16px solid transparent',
                    borderRight: '16px solid transparent',
                    borderTop: `14px solid ${clockedIn ? 'steelblue' : 'white'}`,
                }}/>

                { !clockedIn &&
                    <div className={ 'rounded-circle circle-border ' }
                        style={{ 
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            width: '30px', 
                            height: '30px',
                            backgroundColor: 'white',
                        }}>
                        <span className="fa-stack fa-2x" style={{ fontSize: '12px', marginTop: '3px' }}>
                            <i className="fa-solid fa-ban fa-rotate-90 fa-stack-2x" style={{ color: 'Tomato' }}></i>
                            <i className="fa-solid fa-circle fa-stack-1x" style={{ color: 'white' }}></i>
                            <i className="fa-solid fa-clock fa-stack-1x"></i>
                        </span>
                    </div>
                }
            </Marker>
        </div>
    );
}